import React, { createContext, useCallback, useMemo, useState } from 'react';
import { CanvaEmailImportModal } from '../components/emailBuilder/CanvaEmailImportModal';

export type CanvaImportGuideContextValue = {
  openGuide: () => void;
  recommendedWidthPx: number;
  userId: string | null;
  workspaceId: string | null | undefined;
};

export const CanvaImportGuideContext = createContext<CanvaImportGuideContextValue | null>(null);

type ProviderProps = {
  children: React.ReactNode;
  recommendedWidthPx: number;
  userId: string | null;
  workspaceId?: string | null;
};

export const CanvaImportGuideProvider: React.FC<ProviderProps> = ({
  children,
  recommendedWidthPx,
  userId,
  workspaceId,
}) => {
  const [open, setOpen] = useState(false);
  const openGuide = useCallback(() => setOpen(true), []);

  const value = useMemo(
    () => ({
      openGuide,
      recommendedWidthPx,
      userId,
      workspaceId: workspaceId ?? null,
    }),
    [openGuide, recommendedWidthPx, userId, workspaceId]
  );

  return (
    <CanvaImportGuideContext.Provider value={value}>
      {children}
      <CanvaEmailImportModal
        isOpen={open}
        onClose={() => setOpen(false)}
        recommendedWidthPx={recommendedWidthPx}
        userId={userId}
        workspaceId={workspaceId ?? null}
      />
    </CanvaImportGuideContext.Provider>
  );
};
